var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Log, LogCategory, Operation as LogOperation } from '@augloop/logging';
export function lackingPromiseOrWasmSupport(logOp) {
    var errMsg = '';
    // Exclude IE due to lack of support
    if (typeof window != 'undefined' && window.navigator && window.navigator.userAgent) {
        var ua = window.navigator.userAgent;
        if (!ua.indexOf || ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0) {
            errMsg = 'Error: IE lacks necessary support';
        }
        else if (typeof Promise == 'undefined') {
            errMsg = 'Error: Promise is not supported';
        }
        else if (typeof WebAssembly == 'undefined') {
            errMsg = 'Error: WASM is not supported';
        }
    }
    else {
        errMsg = 'Error: No window userAgent';
    }
    if (errMsg == '') {
        return false;
    }
    else {
        logOp.resultDescription = errMsg;
        Log.info(0x2035f416 /* tag_6n5qw */, LogCategory.CoreDefault, logOp.stop());
        return true;
    }
}
var Model = /** @class */ (function () {
    function Model(session, modelName, onnxObject) {
        this.session = session;
        this.onnxObject = onnxObject;
        this.modelName = modelName;
    }
    /* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
    Model.create = function (modelUrl, modelName, onnxObject) {
        return __awaiter(this, void 0, void 0, function () {
            var createModelOp;
            return __generator(this, function (_a) {
                createModelOp = new LogOperation({
                    operationName: 'CreateModelForInferencing',
                    success: true,
                    resourceId: modelName
                });
                createModelOp.start();
                return [2 /*return*/, this.getInferenceSession(onnxObject).create(modelUrl).then(function (session) {
                        Log.info(0x2035f417 /* tag_6n5qx */, LogCategory.CoreDefault, createModelOp.stop());
                        return new Model(session, modelName, onnxObject);
                    }).catch(function (err) {
                        createModelOp.resultDescription = "Error: " + err;
                        Log.info(0x2035f418 /* tag_6n5qy */, LogCategory.CoreDefault, createModelOp.stop());
                        throw err;
                    })];
            });
        });
    };
    Model.getInferenceSession = function (onnxObject) {
        if (onnxObject === null || onnxObject === void 0 ? void 0 : onnxObject.InferenceSession) {
            return onnxObject.InferenceSession;
        }
        else {
            throw new Error('InferenceSession is not defined');
        }
    };
    Model.prototype.run = function (inputs) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var runModelOp, ogInputs_1, tensorInputs_1;
            var _this = this;
            return __generator(this, function (_b) {
                runModelOp = new LogOperation({
                    operationName: 'RunModelForInferencing',
                    success: true,
                    resourceId: this.modelName
                });
                runModelOp.start();
                if ((_a = this.onnxObject) === null || _a === void 0 ? void 0 : _a.Tensor) {
                    ogInputs_1 = inputs.getInputs();
                    tensorInputs_1 = {};
                    Object.keys(ogInputs_1).forEach(function (inputName2) {
                        var input = ogInputs_1[inputName2];
                        if (Array.isArray(input.values) && input.values.length > 0 && typeof (input.values[0]) === 'boolean') {
                            var uint8sFromBoolValues = new Uint8Array(input.values);
                            tensorInputs_1[inputName2] = new _this.onnxObject.Tensor(uint8sFromBoolValues, input.dimensions);
                        }
                        else {
                            tensorInputs_1[inputName2] = new _this.onnxObject.Tensor(input.values, input.dimensions);
                        }
                    });
                    return [2 /*return*/, this.session.run(tensorInputs_1).then(function (output) {
                            Log.info(0x2035f419 /* tag_6n5qz */, LogCategory.CoreDefault, runModelOp.stop());
                            return new Outputs(output);
                        }).catch(function (err) {
                            runModelOp.resultDescription = "Problem running model. " + err.message;
                            Log.info(0x2035f41a /* tag_6n5q0 */, LogCategory.CoreDefault, runModelOp.stop());
                        })];
                }
                else {
                    runModelOp.resultDescription = "Unable to run model. Tensor not defined";
                    Log.info(0x2035f41b /* tag_6n5q1 */, LogCategory.CoreDefault, runModelOp.stop());
                    throw new Error('Tensor is not defined');
                }
                return [2 /*return*/];
            });
        });
    };
    return Model;
}());
export { Model };
var Inputs = /** @class */ (function () {
    function Inputs() {
        this.map = {};
    }
    Inputs.create = function () {
        return new Inputs();
    };
    Inputs.prototype.getInputs = function () {
        return this.map;
    };
    Inputs.prototype.add = function (name, dimensions, values) {
        this.map[name] = { dimensions: dimensions, values: values };
        return this;
    };
    return Inputs;
}());
export { Inputs };
var Outputs = /** @class */ (function () {
    function Outputs(outputs) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.keys(outputs)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var name_1 = _c.value;
                this[name_1] = new OutputView(name_1, outputs[name_1]);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return Outputs;
}());
var OutputView = /** @class */ (function () {
    function OutputView(name, outputTensor) {
        this.resultName = name;
        this.result = outputTensor;
    }
    OutputView.prototype.name = function () {
        return this.resultName;
    };
    OutputView.prototype.outputType = function () {
        switch (this.result.type) {
            case 'string':
                return 7 /* Strings */;
            case 'int8':
                return 4 /* Int8s */;
            case 'int16':
                return 5 /* Int16s */;
            case 'int32':
                return 6 /* Int32s */;
            case 'bool':
                return 1 /* Booleans */;
            case 'uint8':
                return 8 /* UnsignedInt8s */;
            case 'uint16':
                return 9 /* UnsignedInt16s */;
            case 'uint32':
                return 10 /* UnsignedInt32s */;
            case 'float32':
                return 2 /* Float32s */;
            case 'float64':
                return 3 /* Float64s */;
            default:
                throw new Error("The output type " + this.result.type + " is not supported.");
        }
    };
    OutputView.prototype.dimensions = function () {
        return this.result.dims;
    };
    OutputView.prototype.asBooleans = function () {
        if (this.outputType() === 1 /* Booleans */) {
            return this.result.data.map(function (value) { return !!value; });
        }
        else {
            throw new Error("asBooleans() was called; however, outputType() is " + this.outputType() + ", not Type.Booleans.");
        }
    };
    OutputView.prototype.asFloat32s = function () {
        if (this.outputType() === 2 /* Float32s */) {
            return this.result.data;
        }
        else {
            throw new Error("asFloat32s() was called; however, outputType() is " + this.outputType() + ", not Type.Float32s.");
        }
    };
    OutputView.prototype.asFloat64s = function () {
        if (this.outputType() === 3 /* Float64s */) {
            return this.result.data;
        }
        else {
            throw new Error("asFloat64s() was called; however, outputType() is " + this.outputType() + ", not Type.Float64s.");
        }
    };
    OutputView.prototype.asInt8s = function () {
        if (this.outputType() === 4 /* Int8s */) {
            return this.result.data;
        }
        else {
            throw new Error("asInt8s() was called; however, outputType() is " + this.outputType() + ", not Type.Int8s.");
        }
    };
    OutputView.prototype.asInt16s = function () {
        if (this.outputType() === 5 /* Int16s */) {
            return this.result.data;
        }
        else {
            throw new Error("asInt16s() was called; however, outputType() is " + this.outputType() + ", not Type.Int16s.");
        }
    };
    OutputView.prototype.asInt32s = function () {
        if (this.outputType() === 6 /* Int32s */) {
            return this.result.data;
        }
        else {
            throw new Error("asInt32s() was called; however, outputType() is " + this.outputType() + ", not Type.Int32s.");
        }
    };
    OutputView.prototype.asStrings = function () {
        if (this.outputType() === 7 /* Strings */) {
            return this.result.data;
        }
        else {
            throw new Error("asStrings() was called; however, outputType() is " + this.outputType() + ", not Type.Strings.");
        }
    };
    OutputView.prototype.asUnsignedInt8s = function () {
        if (this.outputType() === 8 /* UnsignedInt8s */) {
            return this.result.data;
        }
        else {
            throw new Error("asUnsignedInt8s() was called; however, outputType() is " + this.outputType() + ", not Type.UnsignedInt8s.");
        }
    };
    OutputView.prototype.asUnsignedInt16s = function () {
        if (this.outputType() === 9 /* UnsignedInt16s */) {
            return this.result.data;
        }
        else {
            throw new Error("asUnsignedInt16s() was called; however, outputType() is " + this.outputType() + ", not Type.UnsignedInt16s.");
        }
    };
    OutputView.prototype.asUnsignedInt32s = function () {
        if (this.outputType() === 10 /* UnsignedInt32s */) {
            return this.result.data;
        }
        else {
            throw new Error("asUnsignedInt32s() was called; however, outputType() is " + this.outputType() + ", not Type.UnsignedInt32s.");
        }
    };
    return OutputView;
}());
//# sourceMappingURL=model.js.map